import { Component } from '@angular/core';

import { NgIf } from "@angular/common";
import { InformationElementComponent } from "@alf-nx-workspace/shared/ui";

import { BaseInformationTemplateComponent } from "../../base-information-template.component";
import { InformationElement } from "@alf-nx-workspace/shared/interfaces";
import { GenerischeFreigabeVariables } from "../generische-freigabe.variables";

@Component({
  selector: 'information-template',
  template: `
    <ng-container *ngIf='variableMap'>
      <ng-container *ngIf='workflowAdmin'>
        <shared-ui-information-element
          *ngIf="this.process.ended"
          [information]='getInformationElementProcessEnded()'
          type='date'
          format='dd.MM.yyyy HH:mm'
        ></shared-ui-information-element>
      </ng-container>
      <shared-ui-information-element [information]='getOriginalDocumentFilename()'></shared-ui-information-element>
    </ng-container>
  `,
  styles: [``],
  standalone: true,
  imports: [NgIf, InformationElementComponent]
})
export class InformationTemplateComponent extends BaseInformationTemplateComponent {

  public readonly fields = GenerischeFreigabeVariables;

  constructor() {
    super();
  }

  public getInformationElementProcessEnded() {
    return { name: 'PROCESS.ENDED', value: this.process.ended.toString() };
  }

  public getOriginalDocumentFilename(): InformationElement {
    return {name: 'GENERISCHE-FREIGABE.INFORMATION-TEMPLATE.DOCUMENT', value: this.variableMap.get(this.fields.originalDocumentFilename)};
  }
}
